import { useMemo, useState } from "react";
// import { useNavigate } from "react-router-dom";
import "./Library.css";
import { useBooksStore } from "../state/BooksStore";
import FiltersBar from "../Components/FiltersBar";
import { StatsPanel } from "../Components/StatsPanel";
import BookCard from "../Components/BookCard";

const norm = (s) => (s || "").toLowerCase().trim();

export default function Library() {
  const books = useBooksStore((s) => s.books);
  // const navigate = useNavigate();

  const [filters, setFilters] = useState({
    query: "",
    author: "",
    genre: "",
    status: "all",
    minRating: 0,
    sort: "date-added-desc",
  });

  const counts = useMemo(
    () => ({
      all: books.length,
      tbr: books.filter((b) => b.status === "tbr").length,
      reading: books.filter((b) => b.status === "reading").length,
      finished: books.filter((b) => b.status === "finished").length,
    }),
    [books]
  );

  const visibleBooks = useMemo(() => {
    const q = norm(filters.query);
    const a = norm(filters.author);
    const g = norm(filters.genre);

    let out = [...books];

    if (filters.status !== "all") {
      out = out.filter((b) => b.status === filters.status);
    }
    if (q) {
      out = out.filter(
        (b) => norm(b.title).includes(q) || norm(b.author).includes(q)
      );
    }
    if (a) {
      out = out.filter((b) => norm(b.author).includes(a));
    }
    if (g) {
      out = out.filter((b) =>
        (b.genres || []).some((tag) => norm(tag).includes(g))
      );
    }
    if (Number(filters.minRating) > 0) {
      out = out.filter(
        (b) => Number(b.rating || 0) >= Number(filters.minRating)
      );
    }

    const cmpMap = {
      "title-asc": (x, y) => norm(x.title).localeCompare(norm(y.title)),
      "title-desc": (x, y) => norm(y.title).localeCompare(norm(x.title)),
      "date-added-asc": (x, y) => Number(x.createdAt) - Number(y.createdAt),
      "date-added-desc": (x, y) => Number(y.createdAt) - Number(x.createdAt),
      "rating-desc": (x, y) => Number(y.rating || 0) - Number(x.rating || 0),
    };

    out.sort(cmpMap[filters.sort] || (() => 0));
    return out;
  }, [books, filters]);

  function handleOpenDetail(id) {
    console.log("open book detail:", id);
    // navigate(`/book/${id}`);
  }

  return (
    <main
      className="app"
      style={{
        maxWidth: 1100,
        margin: "24px auto",
        padding: "0 16px",
        fontFamily: "system-ui, sans-serif",
        color: "#0f172a",
      }}
    >
      <header style={{ marginBottom: 8 }}>
        <h1 style={{ margin: 0, fontSize: 28, fontWeight: 600 }}>
          My Library ✨
        </h1>
        <p style={{ opacity: 0.75, marginTop: 4, fontSize: 14 }}>
          Track, filter, and rate your reads.
        </p>
      </header>

      <StatsPanel books={books} />

      <section style={{ marginTop: 16 }}>
        <FiltersBar
          value={filters}
          onChange={(next) => setFilters((prev) => ({ ...prev, ...next }))}
          counts={counts}
          showingMeta={{ shown: visibleBooks.length, total: books.length }}
        />
      </section>

      <section
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(220px, 1fr))",
          gap: 16,
          marginTop: 16,
        }}
      >
        {visibleBooks.length === 0 ? (
          <div
            style={{
              gridColumn: "1 / -1",
              padding: 24,
              border: "1px dashed #cbd5e1",
              borderRadius: 12,
              textAlign: "center",
              color: "#475569",
              background: "#f8fafc",
              fontSize: 14,
            }}
          >
            <div style={{ fontWeight: 600, marginBottom: 6 }}>No matches</div>
            <div>Try clearing filters or changing your search.</div>
          </div>
        ) : (
          visibleBooks.map((b) => (
            <BookCard key={b.id} book={b} onOpen={handleOpenDetail} />
          ))
        )}
      </section>
    </main>
  );
}
